// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permission_avatar {
    width: 45px;
    min-width: 45px;
    height: 45px;
    min-height: 45px;
    border-radius: 50%;
    margin-right: 1rem;
    background-size: cover;
}
.permission_card_title {
    color: rgba(0,0,0,0.85);
    font-size: 0.9rem;
    margin-bottom: 2px;
    position: relative;
}
.permission_card_text {
    color: rgba(0,0,0,0.5);
}
.permission_card_title_hide {
    opacity: 0;
}
.permission_card_text_hide {
    opacity: 0;
}
.permission_top_row {
    display: flex;
    align-items: flex-start;
}
.permission_settings_icon {
    position: absolute;
    cursor: pointer;
    left: -2rem;
    top: 0.2rem;
    z-index: 99;
}
.permission_table_footer {
    width: 100%;
    height: 74px;
    background-color: rgba(159, 172, 199, 0.15);
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 1rem;
}
.permission_footer_text {
    color: rgba(145, 145, 160, 1);
}
.permissions_select_box {
    position: absolute;
    z-index: 100;
    top: -10px;
}

@media (max-width: 600px){
    .permissions_select_box{
        right:-10px;
        z-index: 2000;
    }
}



.permission_menu_box {
    position: relative;
    margin-left: 25px;
}

.permission_info_icon {
    display: none;
}
@media(max-width:600px){
    .permission_info_icon{
        right: 0px;
    }
}

.tooltip .tooltiptext {
    display: none;
}


@media (max-width: 540px) {
    .permission_menu_box > p {
        display: none;
    }
    .permission_info_icon {
        display: block;
        width: 15px;
        height: 15px;
        cursor: pointer;
        position: absolute;
        z-index: 1;
        top: -5px;
    }
    .tooltip .tooltiptext {
        display: inline;
        visibility: hidden;
        width: 120px;
        background-color: #ececf1;
        font-size: 7px;
        color: #9192A0;
        text-align: left;
        padding: 4px;
        border-radius: 3px;
        position: absolute;
        left: 15px;
        z-index: 2;
    }
    .tooltip:hover .tooltiptext {
        visibility: visible;
    }
}
@media (max-width: 480px) {
    .tooltip .tooltiptext {
        top: 22px;
        left: -100px;
    }
}

.space-between_perm {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
@media (max-width: 450px) {
    .space-between_perm {
        display: block;
        margin-bottom: 15px;
    }
}


`, "",{"version":3,"sources":["webpack://./src/pages/userSettings/permissions/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,WAAW;IACX,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,aAAa;IACjB;AACJ;;;;AAIA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;AACA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,WAAW;QACX,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;IACA;QACI,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,yBAAyB;QACzB,cAAc;QACd,cAAc;QACd,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,UAAU;QACV,UAAU;IACd;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,SAAS;QACT,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ","sourcesContent":[".permission_avatar {\n    width: 45px;\n    min-width: 45px;\n    height: 45px;\n    min-height: 45px;\n    border-radius: 50%;\n    margin-right: 1rem;\n    background-size: cover;\n}\n.permission_card_title {\n    color: rgba(0,0,0,0.85);\n    font-size: 0.9rem;\n    margin-bottom: 2px;\n    position: relative;\n}\n.permission_card_text {\n    color: rgba(0,0,0,0.5);\n}\n.permission_card_title_hide {\n    opacity: 0;\n}\n.permission_card_text_hide {\n    opacity: 0;\n}\n.permission_top_row {\n    display: flex;\n    align-items: flex-start;\n}\n.permission_settings_icon {\n    position: absolute;\n    cursor: pointer;\n    left: -2rem;\n    top: 0.2rem;\n    z-index: 99;\n}\n.permission_table_footer {\n    width: 100%;\n    height: 74px;\n    background-color: rgba(159, 172, 199, 0.15);\n    border-radius: 3px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-left: 1rem;\n}\n.permission_footer_text {\n    color: rgba(145, 145, 160, 1);\n}\n.permissions_select_box {\n    position: absolute;\n    z-index: 100;\n    top: -10px;\n}\n\n@media (max-width: 600px){\n    .permissions_select_box{\n        right:-10px;\n        z-index: 2000;\n    }\n}\n\n\n\n.permission_menu_box {\n    position: relative;\n    margin-left: 25px;\n}\n\n.permission_info_icon {\n    display: none;\n}\n@media(max-width:600px){\n    .permission_info_icon{\n        right: 0px;\n    }\n}\n\n.tooltip .tooltiptext {\n    display: none;\n}\n\n\n@media (max-width: 540px) {\n    .permission_menu_box > p {\n        display: none;\n    }\n    .permission_info_icon {\n        display: block;\n        width: 15px;\n        height: 15px;\n        cursor: pointer;\n        position: absolute;\n        z-index: 1;\n        top: -5px;\n    }\n    .tooltip .tooltiptext {\n        display: inline;\n        visibility: hidden;\n        width: 120px;\n        background-color: #ececf1;\n        font-size: 7px;\n        color: #9192A0;\n        text-align: left;\n        padding: 4px;\n        border-radius: 3px;\n        position: absolute;\n        left: 15px;\n        z-index: 2;\n    }\n    .tooltip:hover .tooltiptext {\n        visibility: visible;\n    }\n}\n@media (max-width: 480px) {\n    .tooltip .tooltiptext {\n        top: 22px;\n        left: -100px;\n    }\n}\n\n.space-between_perm {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n@media (max-width: 450px) {\n    .space-between_perm {\n        display: block;\n        margin-bottom: 15px;\n    }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
